$(document).ready(function() {
	//Declare normal variable javascript
	//Hide element when smaller than 1025
	//Breadcrumb title
	$(".btn-exit-mega").on("click", function() {
		$(".has-mega").addClass("hide");
	});
	$(".has-mega a").on("click", function() {
		$(".has-mega").removeClass("hide");
	});
	faqDashboard();

	if ($(window).width() < 1025) {
		$(".top-navigation-wrapper").fadeIn(function() {
			$(".top-navigation-wrapper").css({
				opacity: "1"
			});
		});
		$(".contact-wrapper").fadeIn(function() {
			$(".contact-wrapper").css({
				opacity: "1"
			});
		});
		$(".search-wrapper").fadeIn(function() {
			$(".search-wrapper").css({
				opacity: "1"
			});
		});
		$(".bottom-header").fadeIn(function() {
			$(".bottom-header").css({
				opacity: "1"
			});
		});
		$(".main-navigation-wrapper").fadeIn(function() {
			$(".main-navigation-wrapper").css({
				opacity: "1"
			});
		});
	}
	//Toggle Search
	$(".search-toggle").on("click", function() {
		$(".searchbox").toggleClass("active");
	});
	//Toggle Search

	//Library init
	$(".lightgallery").lightGallery();
	mediumZoom(document.querySelectorAll(".medium-zoom-image"));
	//Declare function Javascript
	tabActive();
	if ($(window).width() > 1024) {
		const $menu = $(".searchbox");
		$(document).mouseup(e => {
			if (
				!$menu.is(e.target) && // if the target of the click isn't the container...
				$menu.has(e.target).length === 0
			) {
				// ... nor a descendant of the container
				$menu.removeClass("active");
			}
		});
	}

	scrollFixHeight();
	paginationTechnology();
	// Mobile Toggle
	toggleMobileMenu();
	toggleMobileSideNavigation();
	//Mapping Secction
	mappingMainNavigation();
	mappingSearch();
	mappingContact();
	mappingTopNavigation();
	toggleApplyForm();
	swiperInit();
	//	Run the function
	if ($("body").hasClass("news-detail-page")) {
		mappingNewsOther();
	}
});
//Check if windows size large then 1024 then these function will be execute
if ($(window).width() > 1024) {
	const $menu = $(".searchbox");
	$(document).mouseup(e => {
		if (
			!$menu.is(e.target) && // if the target of the click isn't the container...
			$menu.has(e.target).length === 0
		) {
			// ... nor a descendant of the container
			$menu.removeClass("active");
		}
	});
}
// Remove when click outside the circle

function paginationTechnology() {
	var items = $(
		".application-technology .row.cards-wrapper .col-sm-6.col-lg-4.cards-item"
	);
	var numItems = items.length;
	var perPage = 9;

	items.slice(perPage).hide();

	$("#pagination-container").pagination({
		items: numItems,
		itemsOnPage: perPage,
		prevText: "&laquo;",
		nextText: "&raquo;",
		onPageClick: function(pageNumber) {
			var showFrom = perPage * (pageNumber - 1);
			var showTo = showFrom + perPage;
			items
				.hide()
				.slice(showFrom, showTo)
				.show();
		}
	});
}

function tabActive() {
	$(".tab-list-navigation li a").on("click", function() {
		$(this)
			.parents(".tab-list-navigation")
			.find("li")
			.removeClass("active");
		$(this)
			.parents("li")
			.addClass("active");

		var display = $(this).attr("data-type");
		$(".tab-item").removeClass("active");
		$("#" + display).addClass("active");
	});
}

function toggleApplyForm() {
	$(".apply-form .button-apply a").on("click", function() {
		$(".form-apply").slideToggle();
	});
}

function faqDashboard() {
	$(".faq-dashboard > li > .title").click(function(e) {
		e.preventDefault();
		if (
			!$(this)
				.parent()
				.hasClass("active")
		) {
			$(".faq-dashboard li .content").slideUp();
			$(this)
				.next()
				.slideToggle();
			$(".faq-dashboard li").removeClass("active");
			$(this)
				.parent()
				.addClass("active");
		} else {
			$(this)
				.next()
				.slideToggle();
			$(".faq-dashboard li").removeClass("active");
		}
	});
}

function scrollFixHeight() {
	let logo = $("header .navbrand");
	if (
		document.body.scrollTop > 50 ||
		document.documentElement.scrollTop > 50
	) {
		logo.addClass("minize");
	} else {
		logo.removeClass("minize");
	}
}

function toggleMobileMenu() {
	$(".mobile-toggle").on("click", function() {
		$(".mobile-wrapper").toggleClass("active");
	});
}

function toggleMobileSideNavigation() {
	$(".side-nav-mobile").on("click", function() {
		$(".side-navigation-list").toggleClass("active");
	});
}

function swiperInit() {
	//home Init
	var homerSwiper = new Swiper(
		".about-us-swiper-single-2 .swiper-container",
		{
			// Optional parameters
			speed: 750,
			slidesPerView: 1,
			effect: "fade",
			fadeEffect: {
				crossFade: true
			},
			autoplay: {
				delay: 3500
			},
			navigation: {
				nextEl: ".swiper-single-next",
				prevEl: ".swiper-single-prev"
			}
		}
	);
	var SwiperAirman = new Swiper(".swiper-airman .swiper-container", {
		// Optional parameters
		speed: 750,
		slidesPerView: 1,
		effect: "fade",
		fadeEffect: {
			crossFade: true
		},
		autoplay: {
			delay: 3500
		}
	});

	var swiperPagination = new Swiper(".swiper-pagination .swiper-container", {
		// Optional parameters
		speed: 750,
		breakpointsInverse: true,
		breakpoints: {
			// when window width is >= 320px
			320: {
				slidesPerView: 3,
				slidesPerColumn: 2
			},
			// when window width is >= 480px
			768: {
				slidesPerView: 3,
				slidesPerColumn: 2
			},
			// when window width is >= 640px
			1025: {
				slidesPerView: 3,
				slidesPerColumn: 3
			}
		},

		pagination: {
			el: ".banner-fluid-caption-pagination",
			type: "bullets",
			clickable: "true"
		}
	});

	var homerSwiper = new Swiper(".banner-fluid-caption .swiper-container", {
		// Optional parameters
		speed: 750,
		slidesPerView: 1,
		effect: "fade",
		autoplay: {
			delay: 3000
		},
		fadeEffect: {
			crossFade: true
		},
		pagination: {
			el: ".banner-fluid-caption-pagination",
			type: "bullets",
			clickable: "true"
		}
	});
	var productDetailSwiper = new Swiper(
		".product-detail-swiper .swiper-container",
		{
			// Optional parameters
			loop: true,
			speed: 750,
			slidesPerView: 1,
			autoplay: {
				delay: 3000
			},
			effect: "fade",
			fadeEffect: {
				crossFade: true
			},
			navigation: {
				nextEl: ".swiper-custom-button-next",
				prevEl: ".swiper-custom-button-prev"
			}
		}
	);

	var homerGallerySwiper = new Swiper(
		".home-swiper-gallery .swiper-container",
		{
			// Optional parameters
			speed: 750,
			slidesPerView: 1,
			effect: "fade",
			autoplay: {
				delay: 3000
			},
			fadeEffect: {
				crossFade: true
			},
			pagination: {
				el: ".home-gallery-pagination",
				type: "bullets",
				clickable: "true"
			}
		}
	);
	var homerGallerySwiper = new Swiper(".home-swiper-news .swiper-container", {
		// Optional parameters
		speed: 750,
		slidesPerView: 1,
		autoplay: {
			delay: 3000
		},
		effect: "fade",
		fadeEffect: {
			crossFade: true
		},
		pagination: {
			el: ".home-news-pagination",
			type: "bullets",
			clickable: "true"
		}
	});
	var swiperPartner = new Swiper(".home-swiper-partner .swiper-container", {
		slidesPerView: 2,
		slidesPerColumn: 3,
		speed: 750,
		spaceBetween: 20,
		autoplay: {
			delay: 2500
		}
	});
	var swiperPartner2 = new Swiper(
		".home-swiper-partner-2 .swiper-container",
		{
			slidesPerView: 2,
			slidesPerColumn: 3,
			speed: 750,
			spaceBetween: 20,
			autoplay: {
				delay: 3500
			}
		}
	);
	var homerSwiper = new Swiper(".top-banner .swiper-container", {
		// Optional parameters
		speed: 750,
		slidesPerView: 1,
		effect: "fade",
		fadeEffect: {
			crossFade: true
		},
		autoplay: {
			delay: 2700
		},
		pagination: {
			el: ".top-banner-pagination",
			type: "bullets",
			clickable: "true"
		}
	});
	var TrinitySwiper = new Swiper(".trinity-swiper .swiper-container", {
		// Optional parameters
		spaceBetween: 15,
		speed: 750,
		autoplay: {
			delay: 2700
		},
		breakpointsInverse: true,
		breakpoints: {
			// when window width is >= 320px
			320: {
				slidesPerView: 1
			},
			// when window width is >= 480px
			768: {
				slidesPerView: 2
			},
			// when window width is >= 640px
			1025: {
				slidesPerView: 3
			}
		},
		navigation: {
			nextEl: ".swiper-custom-button-next",
			prevEl: ".swiper-custom-button-prev"
		}
	});
	var HomeInformation = new Swiper(
		".home-information-swiper .swiper-container",
		{
			// Optional parameters
			spaceBetween: 25,
			loop: true,
			speed: 750,
			autoplay: {
				delay: 3500
			},
			breakpointsInverse: true,
			breakpoints: {
				// when window width is >= 320px
				320: {
					slidesPerView: 1
				},
				// when window width is >= 480px
				768: {
					slidesPerView: 2
				},
				// when window width is >= 640px
				1025: {
					slidesPerView: 3
				}
			},
			navigation: {
				nextEl: ".home-information-next",
				prevEl: ".home-information-prev"
			}
		}
	);
	//About Company Swiper
	var QuadSwiper = new Swiper(".quad-swiper .swiper-container", {
		// Optional parameters
		speed: 750,
		loop: false,
		autoplay: {
			delay: 3500
		},
		breakpointsInverse: true,
		spaceBetween: 15,
		breakpoints: {
			// when window width is >= 320px
			320: {
				slidesPerView: 1
			},
			// when window width is >= 480px
			768: {
				slidesPerView: 3
			},
			// when window width is >= 640px
			1025: {
				slidesPerView: 4
			}
		},
		navigation: {
			nextEl: ".swiper-custom-button-next",
			prevEl: ".swiper-custom-button-prev"
		}
	});

	//Trigger multiple swiper aboout
	$(".about-us-swiper .swiper-container").each(function(index, element) {
		var $this = $(this);
		$this.addClass("instance-" + index);
		$this.find(".about-us-prev").addClass("btn-prev-" + index);
		$this.find(".about-us-next").addClass("btn-next-" + index);
		var swiper = new Swiper(".instance-" + index, {
			speed: 750,
			breakpointsInverse: true,
			spaceBetween: 5,
			autoplay: {
				delay: 3500
			},
			breakpoints: {
				// when window width is >= 320px
				320: {
					slidesPerView: 1
				},
				// when window width is >= 480px
				768: {
					slidesPerView: 2
				},
				// when window width is >= 640px
				1025: {
					slidesPerView: 2
				}
			},
			navigation: {
				nextEl: ".btn-next-" + index,
				prevEl: ".btn-prev-" + index
			}
			// your settings ...
		});
	});

	//Home Quad Swiper
	var QuadSwiper = new Swiper(".home-product-quad-swiper .swiper-container", {
		// Optional parameters
		speed: 750,
		breakpointsInverse: true,
		spaceBetween: 20,
		autoplay: {
			delay: 2500
		},
		breakpoints: {
			// when window width is >= 320px
			320: {
				slidesPerView: 2
			},
			// when window width is >= 480px
			768: {
				slidesPerView: 3
			},
			// when window width is >= 640px
			1025: {
				slidesPerView: 4
			}
		},
		navigation: {
			nextEl: ".home-product-next",
			prevEl: ".home-product-prev"
		}
	});
}

function mappingTopNavigation() {
	return new MappingListener({
		selector: ".top-navigation-wrapper",
		mobileWrapper: ".mobile-wrapper",
		mobileMethod: "appendTo",
		desktopWrapper: ".header-wrapper-top",
		desktopMethod: "prependTo",
		breakpoint: 1025
	}).watch();
}

function mappingContact() {
	return new MappingListener({
		selector: ".contact-wrapper",
		mobileWrapper: ".mobile-wrapper",
		mobileMethod: "appendTo",
		desktopWrapper: ".header-wrapper-top",
		desktopMethod: "prependTo",
		breakpoint: 1025
	}).watch();
}

function mappingSearch() {
	return new MappingListener({
		selector: ".search-wrapper",
		mobileWrapper: ".mobile-wrapper",
		mobileMethod: "appendTo",
		desktopWrapper: ".header-wrapper-top",
		desktopMethod: "prependTo",
		breakpoint: 1025
	}).watch();
}

function mappingMainNavigation() {
	return new MappingListener({
		selector: ".main-navigation-wrapper",
		mobileWrapper: ".mobile-wrapper",
		mobileMethod: "appendTo",
		desktopWrapper: ".header-wrapper-bottom",
		desktopMethod: "appendTo",
		breakpoint: 1025
	}).watch();
}

function mappingNewsOther() {
	return new MappingListener({
		selector: ".news-others-wrapper",
		mobileWrapper: ".side-navigation-wrapper",
		mobileMethod: "insertAfter",
		desktopWrapper: ".news-detail",
		desktopMethod: "appendTo",
		breakpoint: 5000
	}).watch();
}

//Document onliick video
$(document).on("click", ".wrapper video", function(e) {
	var video = $(this).get(0);
	if (video.paused === false) {
		video.pause();
		$(this)
			.parent()
			.find(".play__icon")
			.fadeIn();
		$(this)
			.parents(".wrapper")
			.find(".swiper-caption")
			.fadeIn();
	} else {
		video.play();
		$(this)
			.parent()
			.find(".play__icon")
			.fadeOut();
		$(this)
			.parents(".wrapper")
			.find(".swiper-caption")
			.fadeOut();
	}
	return false;
});
$(function() {
	var $ul = $(".sidebar-navigation > ul");

	$ul.find("li .title em").click(function(e) {
		var $li = $(this)
			.parent()
			.parent();

		if ($li.find("ul").length > 0) {
			e.preventDefault();

			if ($li.hasClass("selected")) {
				$li.removeClass("selected")
					.find("li")
					.removeClass("selected");
				$li.find("ul").slideUp(400);
				$li.find(".title em").removeClass("mdi-flip-v");
			} else {
				if ($li.parents("li.selected").length == 0) {
					$ul.find("li").removeClass("selected");
					$ul.find("ul").slideUp(400);
					$ul.find("li .title em").removeClass("mdi-flip-v");
				} else {
					$li.parent()
						.find("li")
						.removeClass("selected");
					$li.parent()
						.find("> li ul")
						.slideUp(400);
					$li.parent()
						.find("> li .title em")
						.removeClass("mdi-flip-v");
				}

				$li.addClass("selected");
				$li.find(">ul").slideDown(400);
				$li.find(">.title>em").addClass("mdi-flip-v");
			}
		}
	});

	$(".sidebar-navigation > ul ul").each(function(i) {
		if ($(this).find(">li>ul").length > 0) {
			var paddingLeft = $(this)
				.parent()
				.parent()
				.find(">li>.title")
				.css("padding-left");
			var pIntPLeft = parseInt(paddingLeft);
			var result = pIntPLeft + 10;

			$(this)
				.find(">li>.title")
				.css("padding-left", result);
		} else {
			var paddingLeft = $(this)
				.parent()
				.parent()
				.find(">li>.title")
				.css("padding-left");
			var pIntPLeft = parseInt(paddingLeft);
			var result = pIntPLeft + 0;

			$(this)
				.find(">li>.title")
				.css("padding-left", result)
				.parent()
				.addClass("selected--last");
		}
	});

	var t = " li > ul ";
	for (var i = 1; i <= 10; i++) {
		$(".sidebar-navigation > ul > " + t.repeat(i)).addClass(
			"subMenuColor" + i
		);
	}

	var activeLi = $("li.selected");
	if (activeLi.length) {
		opener(activeLi);
	}

	function opener(li) {
		var ul = li.closest("ul");
		if (ul.length) {
			li.addClass("selected");
			ul.addClass("open");
			li.find(">.title>em").addClass("mdi-flip-v");

			if (ul.closest("li").length) {
				opener(ul.closest("li"));
			} else {
				return false;
			}
		}
	}
});
